import { render, staticRenderFns } from "./cobranca.vue?vue&type=template&id=679296e4&scoped=true"
import script from "./cobranca.vue?vue&type=script&lang=js"
export * from "./cobranca.vue?vue&type=script&lang=js"
import style0 from "./cobranca.vue?vue&type=style&index=0&id=679296e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679296e4",
  null
  
)

export default component.exports